// extracted by mini-css-extract-plugin
export default {"adminLayout":"AdminLayout_adminLayout__rJPJZ","adminContent":"AdminLayout_adminContent__y1e4m"};